import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import './MapWithIcons.css';
import { MarkerOnIcon, MarkerNoLockbeatIcon, MarkerLockbeatIcon, MarkerBellIcon } from '../../icons';
import Map from '../Map';
import classNames from 'classnames';
import { SetHelper } from '../../../helpers';

class MapWithIcons extends Component {
  constructor(props) {
    super(props);
    this.MarkerOnIcon = renderToString(<MarkerOnIcon />);
    this.MarkerNoLockbeatIcon = renderToString(<MarkerNoLockbeatIcon />);
    this.MarkerLockbeatIcon = renderToString(<MarkerLockbeatIcon />);
    this.MarkerBellIcon = renderToString(<MarkerBellIcon />);
  }

  componentDidMount() {
    this.MapInstace = this.props.innerRef.current.wrappedInstance;

    this.MapInstace.whenMapIsReady()
      .then(() => {
        this.setUpIcon((this.props.markers || []).filter(car => !!car.lastPositionPoint));
      })
      .catch(e => console.warn(e));
  }

  componentDidUpdate(prevProps) {
    if (this.props.markers !== prevProps.markers && this.props.markers) {
      this.setUpIcon(this.props.markers.filter(car => !!car.lastPositionPoint));
    }

    if (this.props.imeisWithNotices !== prevProps.imeisWithNotices && this.props.imeisWithNotices) {
      const toBeChanged = this.getChangedImeisAfterUpdate(this.props.imeisWithNotices, prevProps.imeisWithNotices);
      this.setUpIcon(this.props.markers.filter(car => !!car.lastPositionPoint && toBeChanged.has(car.imei)));
    }

    if (this.props.imeisWithLockbeat !== prevProps.imeisWithLockbeat && this.props.imeisWithLockbeat) {
      const toBeChanged = this.getChangedImeisAfterUpdate(this.props.imeisWithLockbeat, prevProps.imeisWithLockbeat);
      this.setUpIcon(this.props.markers.filter(car => !!car.lastPositionPoint && toBeChanged.has(car.imei)));
    }
  }

  /**
   * imeis che c'erano prima e ora non più, più gli imei che ci sono adesso e prima
   */
  getChangedImeisAfterUpdate = (currentImeis, previousImeis) =>
    new SetHelper(currentImeis).minus(previousImeis).unionWith(new SetHelper(previousImeis).minus(currentImeis).asSet());

  setUpIcon = (markers = []) => {
    markers.forEach(car => {
      this.MapInstace.getMap().setMarkerIcon(car.id, this.getMarkerMapperIcons(car));
    });
  };

  markersMapper = car => ({ ...this.props.markersMapper(car), icon: this.getMarkerMapperIcons(car) });

  hasNotice = car => (this.props.imeisWithNotices || []).findIndex(n => n.imei === car.imei) > -1;

  hasLockbeat = car => (this.props.imeisWithLockbeat || []).findIndex(n => n === car.imei) > -1;

  getMarkerMapperIcons = car =>
    this.hasNotice(car) ? this.MarkerBellIcon : this.hasLockbeat(car) ? this.MarkerLockbeatIcon : car.engineon ? this.MarkerOnIcon : this.MarkerNoLockbeatIcon;

  render() {
    const cls = classNames({
      MapWithIcons: true,
      [this.props.className]: !!this.props.className
    });
    return <Map {...this.props} markersMapper={this.markersMapper} className={cls} ref={this.props.innerRef} />;
  }
}

export default React.forwardRef((props, ref) => <MapWithIcons innerRef={ref} {...props} />);



// WEBPACK FOOTER //
// ./src/common/components/MapWithIcons/MapWithIcons.js